import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { loadIntercom, bootIntercom, updateIntercom } from './intercom'
import { getUserInfoFromStorage } from '../../nexchange-service/module/auth'

export const IntercomProvider = () => {
    const router = useRouter()

    if (typeof window !== 'undefined') {
        loadIntercom()
        
        const userInfo = getUserInfoFromStorage()

        const options = {}
        if (userInfo) {
            options['email'] = userInfo.email
        }
        
        bootIntercom(options)
    }

    useEffect(() => {
        const handleRouteChange = url => {
            if (typeof window !== 'undefined') {
                updateIntercom()
            }
        }

        router.events.on('routeChangeStart', handleRouteChange)

        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return () => {
            router.events.off('routeChangeStart', handleRouteChange)
        }
    }, [router.events])

    return null
}
